module.exports = __webpack_public_path__ + "img/VR_en.jpg";